import { useState } from "react";
import useForm from "antd/es/form/hooks/useForm";
import request from "project-config/services/request/request";
import { message } from "antd";
import { useTranslation } from "react-i18next";

export function useExportBill({
  api,
  searchParams,
  frameApi,
  hardwareApi,
  taskFrameApi,
}: {
  api?: string;
  searchParams?: Record<string, any>;
  frameApi?: string;
  hardwareApi?: string;
  taskFrameApi?: string;
}) {
  const [openModal, setModal] = useState(false);
  const [openFrameModal, setFrameModal] = useState(false);
  const [openHardwareModal, setHardwareModal] = useState(false);
  const [openTaskFrameModal, setTaskFrameModal] = useState(false);
  const [exportForm] = useForm();
  const [exportFrameForm] = useForm();
  const [exportHardwareForm] = useForm();
  const [exportTaskFrameForm] = useForm();
  const { t } = useTranslation("center");
  const { t: consumptionT } = useTranslation("consumption");
  const onOk = () => {
    exportForm.validateFields().then(async (v) => {
      const { code } = await request.post(api ?? "", { ...searchParams, ...v });
      if (code === 200) {
        message.success(t("header_user_add_export_list"));
        setModal(false);
        exportForm.setFieldValue("exportName", "");
      }
    });
  };

  const onOkTask = () => {
    exportForm.validateFields().then(async (v) => {
      if (!v.exportName) {
        return;
      }
      try {
        const { code } = await request.post(api ?? "", {
          ...searchParams,
          exportName: v.exportName,
          taskIds: searchParams?.taskIds || [],
          platformName: searchParams?.platform
            ? t(`query_platform_${searchParams.platform}`)
            : undefined,
        });

        if (code === 200) {
          message.success(t("header_user_add_export_list"));
          setModal(false);
          exportFrameForm.setFieldValue("exportName", "");
        }
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleExportFrameBill = (ids: string) => {
    if (!ids || !ids.trim() || !ids.length) {
      message.warning(consumptionT("consumption_export_frame_tip"));
      return;
    }
    setFrameModal(true);
  };

  const onFrameOk = () => {
    exportFrameForm.validateFields().then(async (v) => {
      if (!v.exportName) {
        return;
      }
      try {
        const { code } = await request.post(frameApi ?? "", {
          ...searchParams,
          exportName: v.exportName,
          taskIds: searchParams?.taskIds || [],
          platformName: searchParams?.platform
            ? t(`query_platform_${searchParams.platform}`)
            : undefined,
        });
        if (code === 200) {
          message.success(t("header_user_add_export_list"));
          setFrameModal(false);
          exportFrameForm.setFieldValue("exportName", "");
        }
      } catch (error) {
        console.error(error);
      }
    });
  };

  const onHardwareOk = () => {
    exportHardwareForm.validateFields().then(async (v) => {
      if (!v.exportName) {
        return;
      }
      try {
        const { code } = await request.post(hardwareApi ?? "", {
          startTime: searchParams?.startTime,
          endTime: searchParams?.endTime,
          platform: searchParams?.platform,
          submitUserName: searchParams?.submitUserName,
          userId: searchParams?.userId,
          exportName: v.exportName,
        });
        if (code === 200) {
          message.success(t("header_user_add_export_list"));
          setHardwareModal(false);
          exportHardwareForm.setFieldValue("exportName", "");
        }
      } catch (error) {
        console.error(error);
      }
    });
  };

  const onTaskFrameOk = () => {
    exportTaskFrameForm.validateFields().then(async (v) => {
      if (!v.exportName) {
        return;
      }
      const start = v?.billingPeriod?.[0];
      const end = v?.billingPeriod?.[1];
      try {
        const { code } = await request.post(taskFrameApi ?? "", {
          startTime: start ? start.valueOf() : undefined,
          endTime: end ? end.valueOf() : undefined,
          exportName: v.exportName,
        });
        if (code === 200) {
          message.success(t("header_user_add_export_list"));
          setTaskFrameModal(false);
          exportTaskFrameForm.resetFields();
        }
      } catch (error) {
        console.error(error);
      }
    });
  };
  return {
    openModal,
    setModal,
    exportForm,
    onOk,
    onOkTask,
    openFrameModal,
    setFrameModal,
    exportFrameForm,
    handleExportFrameBill,
    onFrameOk,
    exportHardwareForm,
    openHardwareModal,
    setHardwareModal,
    onHardwareOk,
    openTaskFrameModal,
    setTaskFrameModal,
    exportTaskFrameForm,
    onTaskFrameOk,
  };
}
